// import React, { useState, useEffect } from "react"
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Alert,
//   CardBody,
//   Button,
//   Label,
//   Input,
//   Form,
//   Modal,
//   Badge,
//   FormFeedback,
// } from "reactstrap"
// import Breadcrumb from "../../components/Common/Breadcrumb"
// import { ToastContainer, toast } from "react-toastify"
// import PhoneInput from "react-phone-input-2"
// import "react-phone-input-2/lib/style.css"
// import "react-toastify/dist/ReactToastify.css"
// import { withRouter } from "react-router-dom"
// import { useSelector } from "react-redux"
// import { URLS } from "../../Url"
// import axios from "axios"

// const UserProfile = () => {
//   // State management
//   const [modal_small, setModalSmall] = useState(false)
//   const [otpModal, setOtpModal] = useState(false)
//   const [isEditMode, setIsEditMode] = useState(false)
//   const [profileData, setProfileData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     countryCode: "",
//     sellerMobile: "",
//     profilePic: "",
//     supplierType: "",
//   })
//   const [editForm, setEditForm] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     profilePic: null,
//     supplierType: "",
//   })
//   const [phoneForm, setPhoneForm] = useState({
//     countryCode: "",
//     sellerMobile: "",
//     otp: "",
//   })
//   const [validationErrors, setValidationErrors] = useState({
//     phone: "",
//     otp: "",
//   })
//   const [isSubmitting, setIsSubmitting] = useState(false)

//   const { error, success } = useSelector(state => ({
//     error: state.Profile.error,
//     success: state.Profile.success,
//   }))

//   // Get auth token from localStorage
//   const authUser = JSON.parse(localStorage.getItem("authUser"))
//   const token = authUser?.token

//   // Fetch profile data
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const response = await axios.post(
//           URLS.getProfile,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         )

//         const profile = response.data?.vendorProfile || {}
//         setProfileData(profile)
//         setEditForm({
//           firstName: profile.firstName || "",
//           lastName: profile.lastName || "",
//           email: profile.email || "",
//           profilePic: null,
//           supplierType: profile.supplierType || "",
//         })
//       } catch (error) {
//         toast.error("Failed to fetch profile data")
//       }
//     }

//     fetchProfile()
//   }, [token])

//   // Handlers
//   const handleEditChange = e => {
//     const { name, value } = e.target
//     setEditForm(prev => ({ ...prev, [name]: value }))
//   }

//   const handlePhoneChange = (value, country) => {
//     // Clear previous validation errors
//     setValidationErrors(prev => ({ ...prev, phone: "" }))

//     setPhoneForm(prev => ({
//       ...prev,
//       countryCode: country.dialCode,
//       sellerMobile: value.replace(country.dialCode, ""),
//     }))
//   }

//   const handleOtpChange = e => {
//     const { value } = e.target
//     // Only allow numbers and limit to 6 digits
//     if (/^\d{0,4}$/.test(value)) {
//       setPhoneForm(prev => ({ ...prev, otp: value }))
//       // Clear validation error when user types
//       setValidationErrors(prev => ({ ...prev, otp: "" }))
//     }
//   }

//   const handleFileChange = e => {
//     const file = e.target.files[0]
//     if (!file) return

//     const validTypes = ["image/jpeg", "image/png", "image/jpg"]
//     if (!validTypes.includes(file.type)) {
//       toast.error("File format not supported. Please choose JPG, JPEG, or PNG.")
//       e.target.value = null
//       return
//     }

//     // Check file size (max 2MB)
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("File size too large. Please choose a file smaller than 2MB.")
//       e.target.value = null
//       return
//     }

//     setEditForm(prev => ({ ...prev, profilePic: file }))
//   }

//   // Validation functions
//   const validatePhoneNumber = () => {
//     if (!phoneForm.sellerMobile || phoneForm.sellerMobile.length < 10) {
//       setValidationErrors(prev => ({
//         ...prev,
//         phone: "Phone number must be at least 10 digits",
//       }))
//       return false
//     }

//     // Additional validation for specific country codes if needed
//     if (
//       phoneForm.countryCode === "91" &&
//       phoneForm.sellerMobile.length !== 10
//     ) {
//       setValidationErrors(prev => ({
//         ...prev,
//         phone: "Indian phone numbers must be 10 digits",
//       }))
//       return false
//     }

//     setValidationErrors(prev => ({ ...prev, phone: "" }))
//     return true
//   }

//   const validateOtp = () => {
//     if (!phoneForm.otp || phoneForm.otp.length !== 4) {
//       setValidationErrors(prev => ({
//         ...prev,
//         otp: "OTP must be exactly 6 digits",
//       }))
//       return false
//     }

//     if (!/^\d+$/.test(phoneForm.otp)) {
//       setValidationErrors(prev => ({
//         ...prev,
//         otp: "OTP must contain only numbers",
//       }))
//       return false
//     }

//     setValidationErrors(prev => ({ ...prev, otp: "" }))
//     return true
//   }

//   // Form submissions
//   const handleProfileSubmit = async e => {
//     e.preventDefault()
//     setIsSubmitting(true)

//     try {
//       const formData = new FormData()
//       formData.append("firstName", editForm.firstName)
//       formData.append("lastName", editForm.lastName)
//       formData.append("email", editForm.email)
//       formData.append("supplierType", editForm.supplierType)
//       if (editForm.profilePic) {
//         formData.append("profilePic", editForm.profilePic)
//       }

//       const response = await axios.put(URLS.UpdateProfile, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       })

//       if (response.status === 200) {
//         toast.success(response.data.message)
//         // Refresh profile data
//         const profileResponse = await axios.post(
//           URLS.getProfile,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         )
//         setProfileData(profileResponse.data?.vendorProfile || {})
//         setIsEditMode(false)
//       }
//     } catch (error) {
//       const errorMsg =
//         error.response?.data?.message || "Failed to update profile"
//       toast.error(errorMsg)
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const handlePhoneSubmit = async e => {
//     e.preventDefault()

//     if (!validatePhoneNumber()) return

//     setIsSubmitting(true)

//     try {
//       const response = await axios.post(
//         URLS.UpdatePhone,
//         {
//           newMobileNumber: phoneForm.sellerMobile,
//           countryCode: phoneForm.countryCode,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       )

//       if (response.status === 200) {
//         toast.success(response.data.message)
//         localStorage.setItem("phone", phoneForm.sellerMobile)
//         localStorage.setItem("countryCode", phoneForm.countryCode)
//         setModalSmall(false)
//         setOtpModal(true)
//       }
//     } catch (error) {
//       const errorMsg =
//         error.response?.data?.message || "Failed to update phone number"
//       toast.error(errorMsg)
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const handleOtpSubmit = async e => {
//     e.preventDefault()

//     if (!validateOtp()) return

//     setIsSubmitting(true)

//     try {
//       const response = await axios.put(
//         URLS.UpdateOtp,
//         {
//           sellerMobile: localStorage.getItem("phone"),
//           countryCode: localStorage.getItem("countryCode"),
//           otp: phoneForm.otp,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       )

//       if (response.status === 200) {
//         toast.success(response.data.message)
//         setOtpModal(false)
//         // Reset OTP field
//         setPhoneForm(prev => ({ ...prev, otp: "", sellerMobile: "" }))
//         // Refresh profile data
//         const profileResponse = await axios.post(
//           URLS.getProfile,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         )
//         setProfileData(profileResponse.data?.vendorProfile || {})
//       }
//     } catch (error) {
//       const errorMsg = error.response?.data?.message || "Failed to verify OTP"
//       toast.error(errorMsg)
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   // Toggle functions
//   const togglePhoneModal = () => {
//     setModalSmall(!modal_small)
//     // Reset validation errors when modal closes
//     setValidationErrors({ phone: "", otp: "" })
//     // Reset phone form when modal closes
//     if (modal_small) {
//       setPhoneForm({
//         countryCode: "",
//         sellerMobile: "",
//         otp: "",
//       })
//     }
//   }

//   const toggleOtpModal = () => {
//     setOtpModal(!otpModal)
//     // Reset validation errors when modal closes
//     setValidationErrors({ phone: "", otp: "" })
//     // Reset OTP field when modal closes
//     if (otpModal) {
//       setPhoneForm(prev => ({ ...prev, otp: "" }))
//     }
//   }

//   const toggleEditMode = () => {
//     setIsEditMode(!isEditMode)
//     // Reset edit form when canceling
//     if (isEditMode) {
//       setEditForm({
//         firstName: profileData.firstName || "",
//         lastName: profileData.lastName || "",
//         email: profileData.email || "",
//         profilePic: null,
//       })
//     }
//   }

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           <Breadcrumb title="Bizzmate Supplier" breadcrumbItem="Profile" />
//           <Row>
//             <Col lg="12">
//               {error && <Alert color="danger">{error}</Alert>}
//               {success && <Alert color="primary">{success}</Alert>}
//               <div
//                 className="mb-2 p-2"
//                 style={{ border: "1px solid #007BC8", borderRadius: "5px" }}
//               >
//                 <h5
//                   style={{
//                     color: "#007BC8",
//                     fontWeight: "600",
//                     fontStyle: "SemiBold",
//                   }}
//                 >
//                   Profile Data
//                 </h5>
//               </div>
//               <Card>
//                 <CardBody>
//                   <div className="profile-header">
//                     <Row className="align-items-center">
//                       <Col md={2}>
//                         <div
//                           className="profile-picture-container"
//                           style={{ position: "relative" }}
//                         >
//                           <img
//                             src={`${URLS.Base}${profileData.profilePic}`}
//                             alt="profile"
//                             className="rounded-circle img-thumbnail profile-picture"
//                             style={{
//                               width: "150px",
//                               height: "150px",
//                               objectFit: "cover",
//                               border: "5px solid #fff",
//                               boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//                             }}
//                             onError={e => {
//                               e.target.src = "https://via.placeholder.com/150"
//                             }}
//                           />
//                         </div>
//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "90px",
//                             right: "20px",
//                           }}
//                         >
//                           <Button
//                             color={isEditMode ? "danger" : "primary"}
//                             onClick={toggleEditMode}
//                             disabled={isSubmitting}
//                           >
//                             {isEditMode ? (
//                               <i
//                                 className="bx bx-x"
//                                 style={{ fontSize: "15px" }}
//                               ></i>
//                             ) : (
//                               <>
//                                 <i
//                                   className="bx bx-edit"
//                                   style={{ fontSize: "15px" }}
//                                 ></i>
//                               </>
//                             )}
//                           </Button>
//                         </div>
//                       </Col>
//                     </Row>
//                   </div>
//                   {!isEditMode ? (
//                     <div className="mt-3">
//                       <h5
//                         className="mb-3 "
//                         style={{
//                           color: "#007BC8",
//                           fontWeight: "600",
//                           fontStyle: "SemiBold",
//                         }}
//                       >
//                         Personal Information
//                       </h5>
//                       <Row>
//                         <Col md={6}>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">
//                               First Name
//                             </Label>
//                             <p>{profileData.firstName}</p>
//                           </div>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">Email</Label>
//                             <p>{profileData.email}</p>
//                           </div>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">
//                               Supplier Type
//                             </Label>
//                             <p>{profileData.supplierType}</p>
//                           </div>
//                         </Col>
//                         <Col md={6}>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">
//                               Last Name
//                             </Label>
//                             <p>{profileData.lastName}</p>
//                           </div>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">
//                               Phone Number
//                             </Label>
//                             <p>
//                               {profileData.countryCode &&
//                                 `+${profileData.countryCode} `}
//                               {profileData.sellerMobile}
//                             </p>
//                           </div>
//                           <div className="mb-3">
//                             <Label className="font-weight-bold">
//                               Account Status
//                             </Label>
//                             <p>
//                               <Badge color="primary" className="py-1 px-2">
//                                 Active
//                               </Badge>
//                             </p>
//                           </div>
//                         </Col>
//                       </Row>
//                     </div>
//                   ) : (
//                     <Form onSubmit={handleProfileSubmit} className="mt-4">
//                       <h5 className="mb-3">Edit Profile</h5>
//                       <Row>
//                         <Col md={6} className="mb-3">
//                           <Label>First Name</Label>
//                           <Input
//                             name="firstName"
//                             placeholder="Enter First Name"
//                             type="text"
//                             value={editForm.firstName}
//                             onChange={handleEditChange}
//                             required
//                           />
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <Label>Last Name</Label>
//                           <Input
//                             name="lastName"
//                             placeholder="Enter Last Name"
//                             type="text"
//                             value={editForm.lastName}
//                             onChange={handleEditChange}
//                             required
//                           />
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <Label>Email</Label>
//                           <Input
//                             name="email"
//                             placeholder="Enter Email"
//                             type="email"
//                             value={editForm.email}
//                             onChange={handleEditChange}
//                           />
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <Label>
//                             Phone Number
//                             <Button
//                               color="link"
//                               className="p-0 ml-2"
//                               onClick={togglePhoneModal}
//                               type="button"
//                             >
//                               <small>Change Number</small>
//                             </Button>
//                           </Label>
//                           <PhoneInput
//                             country={"in"}
//                             value={
//                               profileData.countryCode
//                                 ? `+${profileData.countryCode}${profileData.sellerMobile}`
//                                 : profileData.sellerMobile
//                             }
//                             inputClass="form-control"
//                             disabled
//                             dropdownClass="country-dropdown"
//                             placeholder="Phone number"
//                             enableSearch
//                           />
//                         </Col>
//                         <Col md="6">
//                           <div className="mb-3">
//                             <Label>Supplier Type</Label>
//                             <Input
//                               type="select"
//                               name="supplierType"
//                               value={editForm.supplierType}
//                               onChange={handleEditChange}
//                               required
//                             >
//                               <option value="">Select Type</option>
//                               <option value="Company">Company</option>
//                               <option value="Retailer">Retailer</option>
//                             </Input>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <Label>Profile Picture</Label>
//                           <div className="custom-file">
//                             <Input
//                               type="file"
//                               className="custom-file-input"
//                               id="profilePic"
//                               onChange={handleFileChange}
//                               accept="image/jpeg, image/png, image/jpg"
//                             />
//                             <Label
//                               className="custom-file-label"
//                               htmlFor="profilePic"
//                             >
//                               {editForm.profilePic?.name || "Choose file..."}
//                             </Label>
//                           </div>
//                           <small className="text-muted">
//                             Recommended size: 260x190 pixels (JPG, PNG, max 2MB)
//                           </small>
//                         </Col>
//                       </Row>
//                       <div className="text-right mt-4">
//                         <Button
//                           style={{ float: "right" }}
//                           color="primary"
//                           size="sm"
//                           type="submit"
//                           disabled={isSubmitting}
//                         >
//                           {isSubmitting ? (
//                             <>
//                               <span
//                                 className="spinner-border spinner-border-sm mr-2"
//                                 role="status"
//                                 aria-hidden="true"
//                               ></span>
//                               Saving...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fas fa-check-circle mr-1"></i> Save Changes
//                             </>
//                           )}
//                         </Button>
//                       </div>
//                     </Form>
//                   )}
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//           <Modal isOpen={modal_small} toggle={togglePhoneModal} centered>
//             <div className="modal-header">
//               <h5 className="modal-title">Change Phone Number</h5>
//               <button
//                 type="button"
//                 className="close"
//                 onClick={togglePhoneModal}
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <Form onSubmit={handlePhoneSubmit}>
//                 <div className="mb-3">
//                   <Label>New Phone Number</Label>
//                   <PhoneInput
//                     country={"in"}
//                     value={
//                       phoneForm.countryCode
//                         ? `+${phoneForm.countryCode}${phoneForm.sellerMobile}`
//                         : phoneForm.sellerMobile
//                     }
//                     onChange={handlePhoneChange}
//                     inputClass="form-control"
//                     dropdownClass="country-dropdown"
//                     placeholder="Enter new phone number"
//                     enableSearch
//                     required
//                     inputProps={{
//                       required: true,
//                       autoFocus: true,
//                     }}
//                   />
//                   {validationErrors.phone && (
//                     <FormFeedback type="invalid" style={{ display: "block" }}>
//                       {validationErrors.phone}
//                     </FormFeedback>
//                   )}
//                 </div>
//                 <div className="d-flex justify-content-between mt-4">
//                   <Button
//                     color="danger"
//                     onClick={togglePhoneModal}
//                     disabled={isSubmitting}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     size="sm"
//                     color="primary"
//                     type="submit"
//                     disabled={
//                       isSubmitting ||
//                       !phoneForm.sellerMobile ||
//                       phoneForm.sellerMobile.length < 10
//                     }
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm mr-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Sending...
//                       </>
//                     ) : (
//                       "Send OTP"
//                     )}
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </Modal>
//           <Modal isOpen={otpModal} toggle={toggleOtpModal} centered>
//             <div className="modal-header">
//               <h5 className="modal-title">Verify OTP</h5>
//               <button
//                 type="button"
//                 className="close"
//                 onClick={toggleOtpModal}
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <Form onSubmit={handleOtpSubmit}>
//                 <div className="mb-3">
//                   <Label>Enter 4-digit OTP sent to your phone</Label>
//                   <Input
//                     type="text"
//                     placeholder="Enter OTP"
//                     name="otp"
//                     value={phoneForm.otp}
//                     onChange={handleOtpChange}
//                     required
//                     maxLength={4}
//                     pattern="[0-9]{4}"
//                     title="Please enter a 4-digit OTP"
//                     invalid={!!validationErrors.otp}
//                     autoFocus
//                   />
//                   {validationErrors.otp && (
//                     <FormFeedback type="invalid">
//                       {validationErrors.otp}
//                     </FormFeedback>
//                   )}
//                 </div>
//                 <div className="d-flex justify-content-between mt-4">
//                   <Button
//                     color="danger"
//                     onClick={toggleOtpModal}
//                     disabled={isSubmitting}
//                     size="sm"
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     color="primary"
//                     type="submit"
//                     size="sm"
//                     disabled={isSubmitting || phoneForm.otp.length !== 4}
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm mr-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Verifying...
//                       </>
//                     ) : (
//                       "Verify"
//                     )}
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </Modal>
//           <ToastContainer position="top-right" autoClose={5000} />
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default withRouter(UserProfile)

import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  Form,
  Modal,
  Badge,
  FormFeedback,
} from "reactstrap"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import "react-toastify/dist/ReactToastify.css"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { URLS } from "../../Url"
import axios from "axios"

const UserProfile = () => {
  // State management
  const [modal_small, setModalSmall] = useState(false)
  const [otpModal, setOtpModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "",
    sellerMobile: "",
    profilePic: "",
    supplierType: "",
  })
  const [editForm, setEditForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    profilePic: null,
    supplierType: "",
  })
  const [phoneForm, setPhoneForm] = useState({
    countryCode: "",
    sellerMobile: "",
    otp: "",
  })
  const [validationErrors, setValidationErrors] = useState({
    phone: "",
    otp: "",
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { error, success } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
  }))

  // Get auth token from localStorage
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const token = authUser?.token

  // Fetch profile data
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.post(
          URLS.getProfile,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )

        const profile = response.data?.vendorProfile || {}
        setProfileData(profile)
        setEditForm({
          firstName: profile.firstName || "",
          lastName: profile.lastName || "",
          email: profile.email || "",
          profilePic: null,
          supplierType: profile.supplierType || "",
        })
      } catch (error) {
        toast.error("Failed to fetch profile data")
      }
    }

    fetchProfile()
  }, [token])

  // Handlers
  const handleEditChange = e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value }))
  }

  const handlePhoneChange = (value, country) => {
    setValidationErrors(prev => ({ ...prev, phone: "" }))
    setPhoneForm(prev => ({
      ...prev,
      countryCode: country.dialCode,
      sellerMobile: value.replace(country.dialCode, ""),
    }))
  }

  const handleOtpChange = e => {
    const { value } = e.target
    if (/^\d{0,4}$/.test(value)) {
      setPhoneForm(prev => ({ ...prev, otp: value }))
      setValidationErrors(prev => ({ ...prev, otp: "" }))
    }
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (!file) return

    const validTypes = ["image/jpeg", "image/png", "image/jpg"]
    if (!validTypes.includes(file.type)) {
      toast.error("File format not supported. Please choose JPG, JPEG, or PNG.")
      e.target.value = null
      return
    }

    if (file.size > 2 * 1024 * 1024) {
      toast.error("File size too large. Please choose a file smaller than 2MB.")
      e.target.value = null
      return
    }

    setEditForm(prev => ({ ...prev, profilePic: file }))
  }

  // Validation functions
  const validatePhoneNumber = () => {
    if (!phoneForm.sellerMobile || phoneForm.sellerMobile.length < 10) {
      setValidationErrors(prev => ({
        ...prev,
        phone: "Phone number must be at least 10 digits",
      }))
      return false
    }

    if (
      phoneForm.countryCode === "91" &&
      phoneForm.sellerMobile.length !== 10
    ) {
      setValidationErrors(prev => ({
        ...prev,
        phone: "Indian phone numbers must be 10 digits",
      }))
      return false
    }

    setValidationErrors(prev => ({ ...prev, phone: "" }))
    return true
  }

  const validateOtp = () => {
    if (!phoneForm.otp || phoneForm.otp.length !== 4) {
      setValidationErrors(prev => ({
        ...prev,
        otp: "OTP must be exactly 4 digits",
      }))
      return false
    }

    if (!/^\d+$/.test(phoneForm.otp)) {
      setValidationErrors(prev => ({
        ...prev,
        otp: "OTP must contain only numbers",
      }))
      return false
    }

    setValidationErrors(prev => ({ ...prev, otp: "" }))
    return true
  }

  // Form submissions
  const handleProfileSubmit = async e => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const formData = new FormData()
      formData.append("firstName", editForm.firstName)
      formData.append("lastName", editForm.lastName)
      formData.append("email", editForm.email)
      formData.append("supplierType", editForm.supplierType)
      if (editForm.profilePic) {
        formData.append("profilePic", editForm.profilePic)
      }

      const response = await axios.put(URLS.UpdateProfile, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })

      if (response.status === 200) {
        toast.success(response.data.message)
        const profileResponse = await axios.post(
          URLS.getProfile,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setProfileData(profileResponse.data?.vendorProfile || {})
        setEditModal(false)
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to update profile"
      toast.error(errorMsg)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handlePhoneSubmit = async e => {
    e.preventDefault()

    if (!validatePhoneNumber()) return

    setIsSubmitting(true)

    try {
      const response = await axios.post(
        URLS.UpdatePhone,
        {
          newMobileNumber: phoneForm.sellerMobile,
          countryCode: phoneForm.countryCode,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      if (response.status === 200) {
        toast.success(response.data.message)
        localStorage.setItem("phone", phoneForm.sellerMobile)
        localStorage.setItem("countryCode", phoneForm.countryCode)
        setModalSmall(false)
        setOtpModal(true)
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to update phone number"
      toast.error(errorMsg)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleOtpSubmit = async e => {
    e.preventDefault()

    if (!validateOtp()) return

    setIsSubmitting(true)

    try {
      const response = await axios.put(
        URLS.UpdateOtp,
        {
          sellerMobile: localStorage.getItem("phone"),
          countryCode: localStorage.getItem("countryCode"),
          otp: phoneForm.otp,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      if (response.status === 200) {
        toast.success(response.data.message)
        setOtpModal(false)
        setPhoneForm(prev => ({ ...prev, otp: "", sellerMobile: "" }))
        const profileResponse = await axios.post(
          URLS.getProfile,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setProfileData(profileResponse.data?.vendorProfile || {})
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Failed to verify OTP"
      toast.error(errorMsg)
    } finally {
      setIsSubmitting(false)
    }
  }

  // Toggle functions
  const togglePhoneModal = () => {
    setModalSmall(!modal_small)
    setValidationErrors({ phone: "", otp: "" })
    if (modal_small) {
      setPhoneForm({
        countryCode: "",
        sellerMobile: "",
        otp: "",
      })
    }
  }

  const toggleOtpModal = () => {
    setOtpModal(!otpModal)
    setValidationErrors({ phone: "", otp: "" })
    if (otpModal) {
      setPhoneForm(prev => ({ ...prev, otp: "" }))
    }
  }

  const toggleEditModal = () => {
    setEditModal(!editModal)
    if (!editModal) {
      setEditForm({
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        email: profileData.email || "",
        profilePic: null,
        supplierType: profileData.supplierType || "",
      })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Bizzmate Supplier" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="primary">{success}</Alert>}
            </Col>
          </Row>

          <Row>
            {/* Left Card - Profile Picture and Basic Info */}
            <Col lg="4">
              <Card>
                <CardBody className="text-center">
                  <div className="mb-3">
                    <img
                      src={`${URLS.Base}${profileData.profilePic}`}
                      alt="profile"
                      className="rounded-circle img-thumbnail"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                      }}
                      onError={e => {
                        e.target.src = "https://via.placeholder.com/150"
                      }}
                    />
                  </div>

                  <h5 className="mb-1" style={{ fontWeight: "600" }}>
                    {profileData.firstName} {profileData.lastName}
                  </h5>

                  <div className="mt-3">
                    <p className="text-muted mb-2">
                      <i className="bx bx-envelope mr-1"></i>
                      {profileData.email}
                    </p>
                    <p className="text-muted mb-2">
                      <i className="bx bx-phone mr-1"></i>+
                      {profileData.countryCode} {profileData.sellerMobile}
                    </p>
                  </div>

                  <div className="mt-2">
                    <Button color="primary" onClick={toggleEditModal} size="sm">
                      <i className="bx bx-edit me-2"></i>
                      Edit Profile
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Right Card - Detailed Information */}
            <Col lg="8">
              <Card>
                <CardBody>
                  <h5
                    className="mb-3"
                    style={{
                      color: "#495057",
                      fontWeight: "600",
                    }}
                  >
                    Profile Data
                  </h5>

                  <div className="mt-4">
                    <h6
                      className="mb-3"
                      style={{
                        color: "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      Personal Information
                    </h6>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          First Name
                        </Label>
                        <p className="mb-0" style={{ fontWeight: "500" }}>
                          {profileData.firstName}
                        </p>
                      </Col>
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Last Name
                        </Label>
                        <p className="mb-0" style={{ fontWeight: "500" }}>
                          {profileData.lastName}
                        </p>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Email
                        </Label>
                        <p className="mb-0" style={{ fontWeight: "500" }}>
                          {profileData.email}
                        </p>
                      </Col>
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Phone Number
                        </Label>
                        <p className="mb-0" style={{ fontWeight: "500" }}>
                          +{profileData.countryCode} {profileData.sellerMobile}
                        </p>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Supplier Type
                        </Label>
                        <p className="mb-0" style={{ fontWeight: "500" }}>
                          {profileData.supplierType}
                        </p>
                      </Col>
                      <Col md={6}>
                        <Label
                          className="text-muted mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Account Status
                        </Label>
                        <div>
                          <b className="text-primary py-1 px-3">Active</b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Edit Profile Modal */}
          <Modal isOpen={editModal} toggle={toggleEditModal} size="lg" centered>
            <div className="modal-header">
              <h5 className="modal-title">Edit Profile</h5>
              <button
                type="button"
                className="close"
                onClick={toggleEditModal}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={handleProfileSubmit}>
                <Row>
                  <Col md={6} className="mb-3">
                    <Label>First Name</Label>
                    <Input
                      name="firstName"
                      placeholder="Enter First Name"
                      type="text"
                      value={editForm.firstName}
                      onChange={handleEditChange}
                      required
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Label>Last Name</Label>
                    <Input
                      name="lastName"
                      placeholder="Enter Last Name"
                      type="text"
                      value={editForm.lastName}
                      onChange={handleEditChange}
                      required
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Label>Email</Label>
                    <Input
                      name="email"
                      placeholder="Enter Email"
                      type="email"
                      value={editForm.email}
                      onChange={handleEditChange}
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Label>
                      Phone Number
                      <Button
                        color="link"
                        className="p-0 ml-2"
                        onClick={togglePhoneModal}
                        type="button"
                      >
                        <small>Change Number</small>
                      </Button>
                    </Label>
                    <PhoneInput
                      country={"in"}
                      value={
                        profileData.countryCode
                          ? `${profileData.countryCode}${profileData.sellerMobile}`
                          : profileData.sellerMobile
                      }
                      inputClass="form-control"
                      disabled
                      dropdownClass="country-dropdown"
                      placeholder="Phone number"
                      enableSearch
                    />
                  </Col>

                  <Col md="6">
                    <div className="mb-3">
                      <Label>Supplier Type</Label>
                      <Input
                        type="select"
                        name="supplierType"
                        value={editForm.supplierType}
                        onChange={handleEditChange}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="Company">Company</option>
                        <option value="Retailer">Retailer</option>
                      </Input>
                    </div>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Label>Profile Picture</Label>
                    <div className="custom-file">
                      <Input
                        type="file"
                        className="custom-file-input"
                        id="profilePic"
                        onChange={handleFileChange}
                        accept="image/jpeg, image/png, image/jpg"
                      />
                      <Label className="custom-file-label" htmlFor="profilePic">
                        {editForm.profilePic?.name || "Choose file..."}
                      </Label>
                    </div>
                    <small className="text-muted">
                      Recommended size: 260x190 pixels (JPG, PNG, max 2MB)
                    </small>
                  </Col>
                </Row>

                <div className="mt-4" style={{float:"right"}}>
                  <Button
                    color="danger"
                    onClick={toggleEditModal}
                    disabled={isSubmitting}
                    className="me-2"
                    size="sm"
                  >
                    Cancel <i className="bx bx-x-circle"></i>
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-check-circle mr-1"></i> Save Changes
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>

          {/* Change Phone Modal */}
          <Modal isOpen={modal_small} toggle={togglePhoneModal} centered>
            <div className="modal-header">
              <h5 className="modal-title">Change Phone Number</h5>
              <button
                type="button"
                className="close"
                onClick={togglePhoneModal}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={handlePhoneSubmit}>
                <div className="mb-3">
                  <Label>New Phone Number</Label>
                  <PhoneInput
                    country={"in"}
                    value={
                      phoneForm.countryCode
                        ? `${phoneForm.countryCode}${phoneForm.sellerMobile}`
                        : phoneForm.sellerMobile
                    }
                    onChange={handlePhoneChange}
                    inputClass="form-control"
                    dropdownClass="country-dropdown"
                    placeholder="Enter new phone number"
                    enableSearch
                    required
                    inputProps={{
                      required: true,
                      autoFocus: true,
                    }}
                  />
                  {validationErrors.phone && (
                    <FormFeedback type="invalid" style={{ display: "block" }}>
                      {validationErrors.phone}
                    </FormFeedback>
                  )}
                </div>

                <div className="d-flex justify-content-between mt-4">
                  <Button
                    size="sm"
                    color="danger"
                    onClick={togglePhoneModal}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="sm"
                    color="primary"
                    type="submit"
                    disabled={
                      isSubmitting ||
                      !phoneForm.sellerMobile ||
                      phoneForm.sellerMobile.length < 10
                    }
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Sending...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>

          {/* OTP Verification Modal */}
          <Modal isOpen={otpModal} toggle={toggleOtpModal} centered>
            <div className="modal-header">
              <h5 className="modal-title">Verify OTP</h5>
              <button
                type="button"
                className="close"
                onClick={toggleOtpModal}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={handleOtpSubmit}>
                <div className="mb-3">
                  <Label>Enter 4-digit OTP sent to your phone</Label>
                  <Input
                    type="text"
                    placeholder="Enter OTP"
                    name="otp"
                    value={phoneForm.otp}
                    onChange={handleOtpChange}
                    required
                    maxLength={4}
                    pattern="[0-9]{4}"
                    title="Please enter a 4-digit OTP"
                    invalid={!!validationErrors.otp}
                    autoFocus
                  />
                  {validationErrors.otp && (
                    <FormFeedback type="invalid">
                      {validationErrors.otp}
                    </FormFeedback>
                  )}
                </div>

                <div className="d-flex justify-content-between mt-4">
                  <Button
                    color="danger"
                    size="sm"
                    onClick={toggleOtpModal}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    disabled={isSubmitting || phoneForm.otp.length !== 4}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Verifying...
                      </>
                    ) : (
                      "Verify"
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>

          <ToastContainer position="top-right" autoClose={5000} />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
